import AddButton from "components/Button/AddButton";
import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownStatusList, EmptyString, FormTypeAdd, PageSize, PageTypeCount, PageTypeGetPaged, PaginationBack, PaginationFirst, PaginationLast, PaginationNext } from "utils/Constant";
import { ApiDeleteCustomer, ApiGetCustomerList } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import EditIcon from "assets/icon/EditIcon";
import PaginationButton from "components/Input/PaginationButton";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import { GetStatus } from "utils/helpers";

export default function Customer(){
    let navigate = useNavigate()

    const { data: customerList, fetch: getCustomerList } = useFetch(ApiGetCustomerList)
    const { fetch: getCustomerCount } = useFetch(ApiGetCustomerList)
    const { fetch: deleteCustomer } = useFetch(ApiDeleteCustomer)

    const [customerName, setCustomerName] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)

    // Dropdown
    const [statusOptions, setStatusOptions] = useState(DropdownStatusList)

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        setLoading(true)

        fBindGrid(0).then(() => {
            setLoading(false)
        })
    },[])

    // Function Api Call
    async function fGetCustomerList(index){
        await getCustomerList({
            data: {
                customerName: customerName,
                status: status,
                pageSize: PageSize,
                pageIndex: parseInt(index),
                pageType: PageTypeGetPaged,
                sortBy: "A.CustomerName",
                sortOrder: "ASC"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        }).finally(() => {
        })
    }
    async function fGetCustomerCount(){
        let dataCount = 0

        await getCustomerCount({
            data: {
                customerName: customerName,
                status: status,
                pageSize: PageSize,
                pageIndex: 0,
                pageType: PageTypeCount,
                sortBy: "A.CustomerName",
                sortOrder: "ASC"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                dataCount = response.data.dataCount
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })

        return dataCount
    }
    async function fDeleteCustomer(customerId){
        await deleteCustomer({
            data: {
                customerId: customerId,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { setSuccessModal({  isOpen: false }) }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function Button
    function fEditBtnClick(customerId){
        navigate("/location/customer/form?customerId=" + customerId + "&formType=Edit")
    }
    function fDeleteBtnClick(customerId){
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading(true)

                    fDeleteCustomer(customerId).then(() => {
                        fBindGrid(pageIndex)
                    }).finally(() => {
                        setLoading(false)
                    })
                }
            }
        })
    }
    function fSearchBtnClick(){
        fBindGrid(0)
    }

    // Function Grid
    async function fBindGrid(index){
        setLoading(true)

        let totalData = await fGetCustomerCount()

        let i = index !== null ? (index !== "" ? parseInt(index) : 0) : 0

        fSetPaginationOptions(totalData, index)
        fGetCustomerList(i).then(() => {
            setLoading(false)
        })      
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = parseInt(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i <= numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fBindGrid(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fBindGrid(index)
        }
    }
    function fPaginationIndexChange(index){
        setPageIndex(index)
        fBindGrid(index)
    }

    function fEnterKeyDown(e){
		if(e.key === 'Enter'){
			fBindGrid(0)
		}
	}

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Customer</span>
            </div>
            <hr />

            <div className="flex flex-col sm:flex-row gap-5 justify-between mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <div className="flex flex-col gap-2 w-full sm:w-72">
                        <span>Customer Name</span>
                        <input className="input" value={ customerName } onChange={(e) => { setCustomerName(e.target.value) }} onKeyDown={(e) => { fEnterKeyDown(e) }} />
                    </div>
                    <div className="flex flex-col gap-2 w-full sm:w-72">
                        <span>Status</span>
                        <Dropdown value={ status } options={ statusOptions } onChange={(e) => { setStatus(e.value) }} placeholder={"All"} />
                    </div>
                </div>
                <div>
                    <div className="flex justify-end items-end h-full">
                        <SearchButton onClick={() => { fSearchBtnClick() }} />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <AddButton onClick={() => { navigate("/location/customer/form?customerId=&formType=" + FormTypeAdd) }} />
            </div>
           
            <div className="mt-5">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Customer Name</th>
                            <th className="font-semibold text-left px-2">Address</th>
                            <th className="font-semibold text-left px-2">Phone</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Status</th>
                            <th className="font-semibold sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        {customerList?.data?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ data.customerName }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.address }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.phone }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className="button flex gap-2" onClick={() => fEditBtnClick( data.customerId )}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === "2" ? "hidden" : "block" }`} onClick={() => fDeleteBtnClick( data.customerId )}>
                                            <TrashIcon className="w-4 fill-white" />
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            />

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading ? (<LoadingModal />) : (<div />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}